import type { FC, ReactNode } from 'react';
import { Link as LinkDoRouter } from 'react-router-dom';
import { Column, Grid, Stack } from '@carbon/react';

import { MarcaMaestra } from '../marcas/MarcaMaestra';
import styles from './PaginaDeAuth.module.scss';

// A PÁGINA DE ENTRADA (login, cadastro, senha, código, consentimento) — o padrão de login do Carbon:
// uma coluna de formulário no grid, sobre o fundo do tema, sem cartão e sem moldura. A marca no
// alto leva de volta à página inicial. O título é o `h1` da página; o resto é do formulário.
// No computador, a metade direita é a foto do tecladista no palco, com o tratamento do fundo da
// página inicial; no celular e no tablet ela não entra, e o formulário fica sozinho.

export const PaginaDeAuth: FC<{
  titulo: string;
  /** Uma linha logo abaixo do título (ex.: "Não tem conta? Cadastre-se"). */
  apoio?: ReactNode;
  children: ReactNode;
}> = ({ titulo, apoio, children }) => (
  <div className={styles.pagina} data-ui-carbon=''>
    <div className={styles.imagem} aria-hidden />
    <Grid>
      <Column sm={4} md={{ span: 6, offset: 1 }} lg={{ span: 6, offset: 1 }} xlg={{ span: 5, offset: 1 }}>
        <LinkDoRouter to='/' className={styles.marca} aria-label='Ir para a página inicial da Maestra'>
          <MarcaMaestra />
        </LinkDoRouter>
        <Stack gap={7} as='main'>
          <Stack gap={3}>
            <h1 className={styles.titulo}>{titulo}</h1>
            {apoio && <p className={styles.apoio}>{apoio}</p>}
          </Stack>
          {children}
        </Stack>
      </Column>
    </Grid>
  </div>
);
